











	import Vue from 'vue';
  import {Component, Emit, Prop} from "vue-property-decorator";
	import AsiCard from "../common/AsiCard.vue";
	import {Icon} from "@/helpers/icons";
	import PlanningEntryListEntry from "@/models/planningEntry/PlanningEntryListEntry";
	import ReportCreateDialog from "@/components/report/ReportCreateDialog.vue";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import CompanySimple from "@/models/company/CompanySimple";

	@Component({
		components: {AsiBtn, ReportCreateDialog, AsiCard}
	})
	export default class PlanningEntryCard extends Vue {

		@Prop({type: Object, required: true})
		public planningEntry!: PlanningEntryListEntry;

		private icons = Icon;
		private createDialogOpen = false;

		private get subtitle(): string {
			return this.planningEntry.order.company.name + ', ' + this.planningEntry.order.name;
		}

		private get title(): string {
			return this.$d(new Date(this.planningEntry.date), 'weekDay') + ', ' + this.$d(new Date(this.planningEntry.date), 'short')
		}

		private get isOverdue(): boolean {
			const dateYesterday = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
			const planningEntryDate = new Date(this.planningEntry.date);
			return dateYesterday > planningEntryDate;
		}

		private get avatarUrl(): string | null {
			if (this.planningEntry === null) return null;
			return CompanySimple.avatarUrlMedium(this.planningEntry.order.company);
		}

		@Emit('reportCreated')
		public reportCreated(): void {
			this.createDialogOpen = false;
		}

	}
